import Button from 'components/Button';
import { Modal, ModalProps } from 'components/Modal';
import messages from './UnsaveChangesModal.messages';
import styles from './UnsaveChangesModal.module.css';

type Props = {
  onRequestClose: VoidFunction;
  onDiscardClick: VoidFunction;
} & ModalProps;

const SaveDiscardingChangesModal = ({
  onRequestClose,
  onDiscardClick,
  ...restOfProps
}: Props): JSX.Element => (
  <Modal
    {...restOfProps}
    onRequestClose={onRequestClose}
    className={styles.saveDiscardingChangesModal}
  >
    <h3 className={styles.saveDiscardingChangesModal__title}>{messages.title}</h3>
    <p className={styles.saveDiscardingChangesModal__text}>{messages.description}</p>

    <div className={styles.saveDiscardingChangesModal__buttons}>
      <Button variant={'outline'} onClick={onRequestClose}>
        {messages.buttonCancel}
      </Button>
      <Button onClick={onDiscardClick}>{messages.buttonDiscard}</Button>
    </div>
  </Modal>
);

export default SaveDiscardingChangesModal;
